import { Router } from '@angular/router';
import { NotificationI18nService } from '../core/util/notification-i18n.service';
import { ProcedimientoID } from '../listado/listado-tramites-emvs/tramite-emvs';

export const MENSAJE_PROCEDIMIENTO_NO_ACTIVO_KEY = 'TRAMITE.ERROR.PROCEDIMIENTO_INACTIVE';

/**
 * Usuario con rol administrativo (id de rol > 1). Misma regla que en los componentes de trámite.
 */
export function esUsuarioAdministrador(user: any): boolean {
  if (!user?.rol?.length) {
    return false;
  }
  const ids = user.rol
    .map((rol: any) => (typeof rol === 'number' ? rol : rol?.id))
    .filter((id: any) => id != null);
  if (!ids.length) {
    return false;
  }
  return Math.max(...ids) > 1;
}

function resolverEsAdmin(userOrIsAdmin?: any | boolean): boolean {
  if (typeof userOrIsAdmin === 'boolean') {
    return userOrIsAdmin;
  }
  return esUsuarioAdministrador(userOrIsAdmin);
}

export function extraerProcedimiento(procedimientoResponse: any): ProcedimientoID | null {
  if (!procedimientoResponse) {
    return null;
  }
  return procedimientoResponse.Procedimiento ?? procedimientoResponse;
}

/**
 * Un procedimiento se considera activo/publicado si es visible, no está de baja
 * y no ha superado su fecha de cierre. Alineado con ProcedimientoService.esNoPublicado (sgback).
 */
export function esProcedimientoActivo(procedimiento: ProcedimientoID | any): boolean {
  if (!procedimiento) {
    return false;
  }
  if (procedimiento.visible !== true) {
    return false;
  }
  if (procedimiento.fechaBaja != null && procedimiento.fechaBaja !== '') {
    return false;
  }
  if (procedimiento.fechaCierre) {
    const cierre = new Date(procedimiento.fechaCierre);
    if (!isNaN(cierre.getTime()) && cierre.getTime() < Date.now()) {
      return false;
    }
  }
  return true;
}

export function redirectProcedimientoNoActivo(
  router: Router,
  notificationI18n: NotificationI18nService
): void {
  notificationI18n.warning(MENSAJE_PROCEDIMIENTO_NO_ACTIVO_KEY, 5000);
  router.navigate(['profile'], { queryParams: { action: 30 } });
}

/**
 * @returns true si el procedimiento no está activo y se ha redirigido al listado
 */
export function bloquearSiProcedimientoNoActivo(
  procedimientoResponse: any,
  router: Router,
  notificationI18n: NotificationI18nService,
  userOrIsAdmin?: any | boolean
): boolean {
  if (resolverEsAdmin(userOrIsAdmin)) {
    return false;
  }
  const proc = extraerProcedimiento(procedimientoResponse);
  if (!esProcedimientoActivo(proc)) {
    redirectProcedimientoNoActivo(router, notificationI18n);
    return true;
  }
  return false;
}
